import { REFRIGERANT_TYPES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/refrigerant_types_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';
import { REFRIGERANT_TYPE_PICKER } from '../utils/RefrigerantUtils';

const initialState: any = standardInitialStateGenerator([REFRIGERANT_TYPE_PICKER]);

// Keyed by `code` ("R-404A"), not `id` — refrigerant_types is a global reference table with a
// VARCHAR natural key and no numeric primary key at all, so the default 'id' would index every
// record under `undefined` and collapse the whole picker to one row.
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState, 'code');
